import { CartAddEvent } from '@theme/events';

class VhCartUpsell extends HTMLElement {
  connectedCallback() {
    this.abort = new AbortController();
    this.button = this.querySelector('button');
    this.error = this.querySelector('[role="alert"]');
    this.button?.addEventListener('click', () => this.addSecond(), { signal: this.abort.signal });
  }

  async addSecond() {
    if (this.pending || !this.button) return;
    this.pending = true;
    const originalLabel = this.button.textContent;
    this.button.disabled = true;
    this.button.textContent = this.dataset.adding;
    this.setAttribute('aria-busy', 'true');
    this.error.hidden = true;
    let confirmed = false;
    try {
      const sections = [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map(el => el.dataset.sectionId))].slice(0, 5);
      const rawProperties = JSON.parse(this.querySelector('[data-properties]')?.textContent || '{}');
      const properties = Array.isArray(rawProperties) ? Object.fromEntries(rawProperties) : (rawProperties || {});
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(this.dataset.variantId), quantity: 1, properties: properties || {} }], sections, sections_url: location.pathname }),
      });
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(data.description || data.message || this.dataset.error);
      confirmed = true;
      const cartResponse = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
      if (!cartResponse.ok) throw new Error(this.dataset.error);
      const cart = await cartResponse.json();
      document.dispatchEvent(new CartAddEvent(cart, 'vh-cart-bundle', { source: 'vh-cart-bundle', action: 'add', itemCount: cart.item_count, variantId: this.dataset.variantId, sections: data.sections || {} }));
    } catch (error) {
      if (confirmed) {
        location.reload();
        return;
      }
      this.error.textContent = error instanceof Error ? error.message : this.dataset.error;
      this.error.hidden = false;
      this.button.disabled = false;
      this.button.textContent = originalLabel;
      this.pending = false;
      this.removeAttribute('aria-busy');
    }
  }

  disconnectedCallback() {
    this.abort?.abort();
  }
}
if (!customElements.get('vh-cart-pair-offer')) customElements.define('vh-cart-pair-offer', VhCartUpsell);
